import React, { useEffect, useState } from "react";
import { Tab, Row, Col, Nav, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./CapabilitiesSection.css";
import { useHomeStore } from "../../../../store/useHomeStore";
import Loader from "../../../Loader";

// const capabilitiesData = [
//   {
//     key: "div31",
//     number: "01",
//     title: "Div 31 – Earthwork and Site Preparation",
//     heading: "Earthwork & Site Preparation",
//     items: [
//       { heading: "Land Clearing & Grubbing", text: "Removal of trees, vegetation, stumps, and debris to prepare site for construction." },
//       { heading: "Mass Grading", text: "Earthmoving to achieve proper elevations and site balance." },
//       { heading: "Fine Grading", text: "Precision grading to final elevations for building pads, roadways, and drainage." },
//       { heading: "Erosion Control", text: "Installation of protective ground measures to prevent soil loss and water runoff." },
//       { heading: "Excavation & Fill", text: "Precision excavation services and proper placement of fill materials." }
//     ]
//   },
//   {
//     key: "div32",
//     number: "02",
//     title: "Div 32 – Site Concrete and Base Preparation",
//     heading: "Site Concrete & Base Preparation",
//     items: [
//       { heading: "Asphalt & Concrete Paving", text: "Coordination with paving contractors for seamless project completion." },
//       { heading: "Parking Lots", text: "Grading and base preparation for commercial and residential parking facilities." },
//       { heading: "Sidewalks and Curbs", text: "Installation of pedestrian walkways and concrete curbing for drainage control." },
//       // { heading: "Roadway Construction", text: "Building roads for subdivisions, commercial developments, and access ways." },
//       { heading: "Aggregate Base Preparation", text: "Proper installation of stone base materials for paving and structures." }
//     ]
//   },
//   {
//     key: "div33",
//     number: "03",
//     title: "Div 33 – Underground Utilities & Trenching",
//     heading: "Underground Utilities & Trenching",
//     items: [
//       { heading: "Storm Drainage Systems", text: "Installation of culverts, catch basins, and drainage pipes for stormwater management." },
//       { heading: "Sanitary Sewer Installation", text: "Laying gravity and force main sewer lines according to municipal specifications." },
//       { heading: "Water Line Installation", text: "Installation of potable water distribution systems including hydrants and valves." },
//       { heading: "Detention Pond Construction", text: "Building stormwater retention and detention facilities for water quality control." },
//       // { heading: "Utility Trenching and Backfill", text: "Safe excavation of trenches and proper backfilling techniques for utility lines." }
//     ]
//   },
//   {
//     key: "storm",
//     number: "04",
//     title: "Storm Cleanup & Emergency Services",
//     heading: "Storm Cleanup & Emergency Services",
//     items: [
//       { heading: "24/7 Emergency Response", text: "Round-the-clock availability for urgent situations requiring immediate attention." },
//       { heading: "Flood Damage Mitigation", text: "Emergency drainage solutions and water diversion to minimize property damage." },
//       { heading: "Storm Debris Removal", text: "Quick cleanup of fallen trees, branches, and debris after severe weather events." },
//       { heading: "Emergency Access Clearing", text: "Clearing roadways and creating temporary access routes after disasters." },
//       // { heading: "Sinkhole Stabilization", text: "Rapid response to assess and stabilize sinkholes threatening structures or roadways." }
//     ]
//   }
// ];


const CapabilitiesTabs = () => {
  const { getCapability, capability } = useHomeStore()
  const [activeKey, setActiveKey] = useState(null);
  const [animateKey, setAnimateKey] = useState(null);
  const [loading, setLoading] = useState(false)

  const handleSelect = (k) => {
    if (k !== activeKey) {
      setAnimateKey("");
      setTimeout(() => setAnimateKey(k), 10);
      setActiveKey(k);
    }
  };

  let getCapabilityData = async () => {
    setLoading(true)
    await getCapability()
    setLoading(false)
  }

  useEffect(() => {
    if (!capability)
      getCapabilityData()

    if (capability?.capability?.length > 0) {
      setActiveKey(capability?.capability[0]?._id);
      setAnimateKey(capability?.capability[0]?._id);
    }
  }, [capability])

  return (
    <section className="capability-section-wrapper py-5">
      <Loader loading={loading}>
        <Container className="theme-container">
          <div className="mb-4 capability-top-heading">
            <p className="section-subtitle">{`Div 33 - ${capability?.subTitle}`}</p>
            <h3 className="mt-2 section-title">{capability?.title}</h3>
          </div>

          <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
            <Row className="tab-row position-relative align-items-center">
              <Col lg={6}>
                <Nav variant="pills" className="flex-column capability-tab-left-col">
                  {(capability?.capability || []).map((item, ele) => {
                    const isActive = activeKey === item?._id;
                    return (
                      <Nav.Item key={item?._id} className="">
                        <Nav.Link
                          eventKey={item?._id}
                          className={`capability-tab d-flex align-items-start pb-3 pt-3 ${isActive ? "active" : ""}`}
                          aria-expanded={isActive}
                        >
                          <div className="me-3">
                            <h5 className="mb-2 tab-number">{ele + 1}</h5>
                            <h6 className="mb-0 tab-title">{`Div 3${ele + 1}-${item?.title}`}</h6>
                          </div>
                          <span className="ms-auto tab-icon-wrap" aria-hidden="true">
                            <FontAwesomeIcon
                              icon={isActive ? faChevronRight : faChevronDown}
                              className={`tab-icon ${isActive ? "active" : ""}`}
                            />
                          </span>
                        </Nav.Link>
                     <Tab.Content className="capability-right-col-content mobileView">
                      <div className={`capability-pane bg-white p-4 p-lg-4 rounded  ${animateKey === item?._id ? "d-block" : "d-none"}`}>
                        <h5 className="text-orange fw-medium mb-3">{item?.title}</h5>
                        {(item?.points || []).map((detail, idx) => (
                          <div key={idx} className="mb-3 ps-3">
                            <strong>{detail?.title}</strong>
                            <p className="mb-0 fs-6">{detail?.description}</p>
                          </div>
                        ))}
                      </div>
                      </Tab.Content>
                      </Nav.Item>
                    );
                  })}
                </Nav>
              </Col>

              <Col lg={6} className="desktopView">
                <Tab.Content className="capability-right-col-content">
                  {(capability?.capability || []).map((item) => (
                    <Tab.Pane key={item?._id} eventKey={item?._id}>
                      <div className={`capability-pane bg-white p-4 p-lg-4 rounded ${animateKey === item?._id ? "animate-bounce" : ""}`}>
                        <h5 className="text-orange fw-medium mb-3">{item?.title}</h5>
                        {(item?.points || []).map((detail, idx) => (
                          <div key={idx} className="mb-3 ps-3">
                            <strong>{detail?.title}</strong>
                            <p className="mb-0 fs-6">{detail?.description}</p>
                          </div>
                        ))}
                      </div>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </Loader>
    </section>
  );
};

export default CapabilitiesTabs;
